import styles from './SimWork.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import TableItem, {TableItemCurrentStateInt} from "../../FormTemplate/TableItem/TableItem";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import SimLastPayment from "./SimLastPayment/SimLastPayment";
import SimLastVolume from "./SimLastVolume/SimLastVolume";
interface ISimList
{
    ctn:string
    [key:string]:any
}
interface ISimItem {
    ctn:string
    //[key:string]:any
}
interface IBundleItem
{
    name:string
    bundleId:string
}
interface ITarifItem
{
    name:string
    bundleId:string
    tarifId:string
}

export default function SimWork()
{

    const refBundleData = useRef(null)
    const [ldrRefBundle,rsRefBundle,exRefBundle] = useApiQuery("/ref/bundle","post",refBundleData);
    const [bundleList, setBundleList] = useState<IBundleItem[]>([])

    const lockListRef = useRef<SelectUnitRefInt>(null)
    const refTarifData = useRef<{bundleId?:string}>(null)
    const [ldrRefTarif,rsRefTarif,exRefTarif] = useApiQuery("/ref/tarif","post",refTarifData);
    const [tarifList, setTarifList] = useState<ITarifItem[]>([])


    const simListData = useRef(null)
    const [ldrSimList,rsSimList,exSimList] = useApiQuery("/core/sim/list","get",simListData);
    const [simList, setSimList] = useState<ISimList[]>([])


    const simInfoData = useRef<{
            ctn: string
        }>(null)
    const [ldrSimInfo,rsSimInfo,exSimInfo] = useApiQuery("/core/sim/info","post",simInfoData);
    const [simInfo, setSimInfo] = useState<any>()


    const simLockData = useRef<{
        ctn: string
        mainLockState: string
    }>(null)
    const [ldrSimLock,rsSimLock,exSimLock] = useApiQuery("/core/sim/lock","post",simLockData);



    const stateRef = useRef<ErrorLineItemRef>(null)


    const [curSim , setCurSim] = useState<ISimItem>()
    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()

    const [showLastPayment, setShowLastPayment] = useState(false)
    const [showLastVolume, setShowLastVolume] = useState(false)


    const [vLock, setVLock] = useState<any[]>([])
    const [lockList, setLockList] = useState<SelectUnitDataInt[]>([
        {
            name: "[0] Разблокирован",
            val: 0
        },
        {
            name: "[2] Блокирован перманентно",
            val: 2
        },
        {
            name: "[1] Блокирован",
            val: 1
        },
        {
            name: "[10] Старт",
            val: 10
        },

    ])



    useEffect(()=>{
        loadSimList()
    },[simListData])

    useEffect(()=>{
        loadTarifList()
    },[refTarifData])


    useEffect(()=>{
        console.log("SIM LIST",simList)
    },[simList])

    useEffect(()=>{
        loadBundleList()
    },[refBundleData])

    useEffect(()=>{
        console.log("curSim",curSim)
        loadSimInfo()
        //if(lockListRef.current && vLock.length)lockListRef.current.resetValue()

    },[curSim])




    const loadSimList = () =>{
        exSimList().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                const x = e?.payload?.map((item)=>{
                    if(item?.simDescOne)
                    {
                        item['soc'] = item?.simDescOne?.soc
                        item['ban'] = item?.simDescOne?.ban
                    }
                    return item
                })

                setSimList(x)
            }
        })
    }

    const loadBundleList = () =>{
        exRefBundle().then((e)=>{
            if(e?.success)
            {
                setBundleList(e?.payload)
            }
        })
    }
    const loadTarifList = () =>{
        exRefTarif().then((e)=>{
            if(e?.success)
            {
                setTarifList(e?.payload)
            }
        })
    }


    const loadSimInfo = () =>{
        if(curSim === undefined) return
        simInfoData.current = {
            ctn: curSim.ctn
        }
        exSimInfo().then((e)=>{
            if(e?.success)
            {
                setSimInfo(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })

    }

    const handleSimLock = ()=>{
        if(! curSim) return;
        if(vLock.length === 0)
        {
            if(stateRef.current)stateRef.current.show("Не выбран тип блокировки",true,3000)
            return
        }

        simLockData.current = {
            ctn: curSim?.ctn,
            mainLockState: vLock[0]
        }
        exSimLock().then((e)=>{
            if(e?.success)
            {
                if(stateRef.current)stateRef.current.show("Задача выполнена",false,5000)
                loadSimList()
                loadSimInfo()
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,0)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }



    return(
       <div className={styles.mainCont} >
           <MainFormTemplate title={"Сим карты"} maxWidth={"100%"} >
               <div className={styles.ldrCont}>
                   <ActiveRecordItem active={!!curSim}></ActiveRecordItem>
                   <div className={styles.ldr}>
                        <WaitLoader loading={ldrSimInfo || ldrSimLock } api={rsSimList} onlyLoading={true}>

                        </WaitLoader>
                   </div>
               </div>

               <div className={styles.itmCont}>
                   <div className={styles.orTitle}>Общие данные</div>
                   <div className={"row w-100"}>
                       <div className={"col-sm-3"}>
                           <InputItem
                               val={simInfo?.ctn }
                               mode={"i"}
                               title={"Номер"}
                               info={"Номер"}
                           ></InputItem>
                       </div>
                       <div className={"col-sm-3"}>
                           <InputItem
                               val={simInfo?.simDescOne?.ban}
                               mode={"i"}
                               title={"Бан"}
                               info={"Бан"}

                           ></InputItem>
                       </div>
                       <div className={"col-sm-3"}>
                           <InputItem
                               val={simInfo?.bundleOne?.name }
                               mode={"i"}
                               title={"Бандл"}
                               info={"Бандл"}

                           ></InputItem>
                       </div>
                       <div className={"col-sm-3"}>
                           <InputItem
                               val={simInfo?.tarifOne?.name }
                               mode={"i"}
                               title={"Тариф"}
                               info={"Тариф"}

                           ></InputItem>
                       </div>

                   </div>
               </div>

               <div className={styles.itmCont}>
                   <div className={styles.orTitle}>Детальная информация</div>
                   <div className={"row w-100"}>
                       <div className={"col-sm-2"}>
                           <div className={styles.tblItm}>
                               <InputItem
                                   val={simInfo?.amount }
                                   mode={"i"}
                                   title={"Баланс"}
                                   info={"Баланс"}
                               ></InputItem>
                               <div className={styles.btnCont}>
                                   <button type="button" className="btn btn-secondary "
                                   onClick={()=>setShowLastPayment(true)}
                                   disabled={!curSim}
                                   >Платежи</button>


                               </div>
                           </div>
                           { showLastPayment && <SimLastPayment onClose={()=>setShowLastPayment(false)} data={simInfo?.simAmountList}/>}
                       </div>
                       <div className={"col-sm-3"}>
                           <div className={styles.tblItm}>
                               <InputItem
                                   val={simInfo?.volume }
                                   mode={"i"}
                                   title={"Трафик"}
                                   info={"Трафик Мб."}
                                   titleShift={1}
                               ></InputItem>
                               <div className={styles.btnCont}>
                                   <button type="button" className="btn btn-secondary "
                                           onClick={()=>setShowLastVolume(true)}
                                           disabled={!curSim}
                                   >Трафик</button>


                               </div>

                           </div>
                           { showLastVolume && <SimLastVolume onClose={()=>setShowLastVolume(false)} data={simInfo?.simVolumeList}/>}

                       </div>
                       <div className={"col-sm-3"}>
                           <div className={styles.tblItm}>
                               <InputItem
                                   val={simInfo?.mainLockCode }
                                   mode={""}
                                   title={"Код тек. блокировки"}
                                   titleShift={4}
                                   info={"Код текущей блокировки"}

                               ></InputItem>
                               <SelectUnit ref={lockListRef} capt={"Блокировка"} inData={lockList} getVal={(e)=>{
                                   setVLock(e)
                               }}/>
                               <div className={styles.btnCont}>
                                   <button type="button" className="btn btn-secondary "
                                           disabled={!vLock.length}
                                           onClick={()=>handleSimLock()}
                                   >Выполнить</button>


                               </div>


                           </div>
                       </div>
                       <div className={"col-sm-2"}>
                           <InputItem
                               val={simInfo?.nextLockCode }
                               mode={""}
                               title={"Код след. блокировки"}
                               titleShift={4}
                               info={"Код следущей блокировки"}

                           ></InputItem>
                       </div>
                       <div className={"col-sm-2"}>
                           <InputItem
                               val={simInfo?.apiLock }
                               mode={""}
                               title={"API блок"}
                               titleShift={0}
                               inputType={1}
                               info={"Статус блокировки по API"}

                           ></InputItem>
                       </div>

                   </div>
               </div>







               <div className={"row"} >
                   <ErrorLineItem ref={stateRef}></ErrorLineItem>
               </div>
           </MainFormTemplate>
           <WaitLoader loading={ldrSimList} api={rsSimList} onlyLoading={true}>
               <TableItem
                    data={simList}
                    column={[
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"ctn",
                            title: "ctn",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"ban",
                            title: "Бан",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"soc",
                            title: "soc",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 20,
                            fieldId:"bundle",
                            title: "Набор",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 20,
                            fieldId:"tarifId",
                            title: "Тариф",
                            mode: "sf",
                        },
                        {
                            type: 2,
                            maxLen: 20,
                            fieldId:"startDate",
                            title: "Отсчет",
                            mode: "sf",
                        },

                        {
                            type: 1,
                            maxLen: 11,
                            fieldId:"amount",
                            title: "Баланс",
                            mode: "sf",
                        },
                        {
                            type: 1,
                            maxLen: 11,
                            fieldId:"volume",
                            title: "Трафик (Мб.)",
                            mode: "sf",
                        },
                        {
                            type: 1,
                            maxLen: 11,
                            fieldId:"mainLockCode",
                            title: "Код блок.",
                            mode: "sf",
                        },
                        {
                            type: 1,
                            maxLen: 11,
                            fieldId:"apiLock",
                            title: "API Lock",
                            mode: "sf",
                        },
                        {
                            type: 0,
                            maxLen: 20,
                            fieldId:"lockReason",
                            title: "Причина",
                            mode: "sf",
                        },

                    ]}
                    onPageCount={25}
                    onReload={loadSimList}
                    exportExcel={true}
                    onRecord={(e)=>setCurSim(e)}
                    saveState={true}
                    baseState={{
                        state: baseState,
                        setState: setBaseState
                    }}




               ></TableItem>
           </WaitLoader>
       </div>
    )
}